module.exports = __webpack_public_path__ + "img/logo-hannah-big.3a9ac885.svg";